"use client";

import { useEffect, useRef, useState } from "react";
import { useRouter, usePathname } from "next/navigation";
import { ShieldAlert } from "lucide-react";

// Route publik — modal ini tidak boleh tampil di sini, apapun sumber event-nya.
const PUBLIC_PATHS = ["/", "/pages/login"]; // sesuaikan dengan path login sebenarnya

export default function SessionExpiredModal() {
  const router = useRouter();
  const pathname = usePathname();
  const [open, setOpen] = useState(false);
  const dismissedRef = useRef(false);

  const isPublicPath = PUBLIC_PATHS.some((p) => pathname === p);

  useEffect(() => {
    const handler = () => {
      // Kalau user baru saja menutup modal secara manual dan masih dalam
      // proses pindah ke halaman publik, abaikan dispatch susulan —
      // ini menahan re-trigger dari AuthGuard/timer yang masih nyangkut.
      if (dismissedRef.current) return;
      setOpen(true);
    };
    window.addEventListener("session-expired", handler);
    return () => window.removeEventListener("session-expired", handler);
  }, []);

  // Begitu benar-benar sampai di halaman publik, paksa tertutup & kunci
  // supaya event susulan tidak membukanya lagi.
  useEffect(() => {
    if (isPublicPath) {
      setOpen(false);
      dismissedRef.current = true;
    }
  }, [isPublicPath]);

  const handleLogin = () => {
    dismissedRef.current = true;
    setOpen(false);
    try {
      localStorage.removeItem("token");
    } catch {
      /* abaikan */
    }
    router.replace("/");
  };

  if (!open || isPublicPath) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />
      <div className="relative w-full max-w-sm overflow-hidden rounded-2xl border border-amber-500/20 bg-[#0a0f1e] p-6 text-center shadow-2xl shadow-black/40">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full border border-amber-500/30 bg-amber-500/10">
          <ShieldAlert className="h-6 w-6 text-amber-400" />
        </div>
        <h2 className="text-lg font-bold text-slate-100">Sesi Telah Habis</h2>
        <p className="mt-1.5 text-sm text-slate-400">
          Sesi Anda telah berakhir. Silakan login kembali untuk melanjutkan.
        </p>
        <button
          type="button"
          onClick={handleLogin}
          className="mt-5 w-full rounded-xl bg-emerald-500/90 px-4 py-2.5 text-sm font-semibold text-slate-950 transition hover:bg-emerald-400"
        >
          Login Kembali
        </button>
      </div>
    </div>
  );
}